import { useState, useEffect } from 'react'
import AnimatedLetters from '../AnimatedLetters'
import Loader from 'react-loaders'
import './index.scss'
import { pricingData } from '../../data/pricing'

const Pricing = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    return (
        <>
            <div className="container pricing-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['P', 'l', 'a', 'n', 's', ' ', '&', ' ', 'P', 'r', 'i', 'c', 'i', 'n', 'g']}
                            idx={15}
                        />
                    </h1>
                    <p>
                        Choose the perfect package for your mobile application needs.
                        From concept to App Store launch, we handle the entire lifecycle.
                    </p>
                </div>

                <div className="pricing-container">
                    {pricingData.map((plan) => (
                        <div className={`card ${plan.popular ? 'popular' : ''}`} key={plan.id}>
                            {plan.popular && <div className="popular-tag"><span className="star-icon"></span> MOST POPULAR</div>}
                            <div className="card-header">
                                <h3>{plan.title}</h3>
                                <span className="price">{plan.price}</span>
                                <p className="for-line">{plan.for}</p>
                            </div>
                            <div className="card-body">
                                <h4>What You Get:</h4>
                                <ul>
                                    {plan.features.map((feature, idx) => (
                                        <li key={idx}>{feature}</li>
                                    ))}
                                </ul>
                                {plan.timeline && <p className="timeline"><strong>Timeline:</strong> {plan.timeline}</p>}
                                <p className="recent-example"><strong>Recent Example:</strong> {plan.example}</p>

                                {!plan.custom && (
                                    <div className="deposit-info">
                                        <h4>{plan.deposit}</h4>
                                        <p className="deposit-note">{plan.depositNote}</p>
                                        <p>After payment, you'll receive:</p>
                                        <ul>
                                            <li>Link to schedule kickoff call</li>
                                            <li>Short intake form (your goals, timeline, must-haves)</li>
                                            <li>Sample SOW (we'll customize and both sign before work starts)</li>
                                        </ul>
                                        <p className="refund-policy">Deposit locks your build slot. Refundable if we mutually decide the project isn't a fit after the kickoff call.</p>
                                    </div>
                                )}

                                <div className={`card-buttons ${plan.custom ? 'single' : ''}`}>
                                    {!plan.custom ? (
                                        <a
                                            href={`/checkout?plan=${plan.id}`}
                                            className="flat-button primary"
                                        >
                                            Book Deposit & Reserve Slot
                                        </a>
                                    ) : (
                                        <a
                                            href={plan.consultationLink}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="flat-button primary"
                                        >
                                            Schedule Discovery Call
                                        </a>
                                    )}
                                    {!plan.custom && (
                                        <a
                                            href={plan.consultationLink}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="flat-button secondary"
                                        >
                                            Talk Through This Package (Free 20-Min Call)
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* How We Work Section */}
                <section className="how-we-work-section">
                    <h2>How We Work</h2>
                    <div className="process-steps">
                        <div className="step">
                            <span className="step-number">1</span>
                            <h4>Discovery & Scope</h4>
                            <span className="duration">1 week</span>
                            <p>Kickoff call, competitive analysis, feature prioritization, wireframes</p>
                        </div>
                        <div className="step">
                            <span className="step-number">2</span>
                            <h4>Design & Architecture</h4>
                            <span className="duration">1–2 weeks</span>
                            <p>UI design, color system, technical architecture, navigation flow</p>
                        </div>
                        <div className="step">
                            <span className="step-number">3</span>
                            <h4>Implementation</h4>
                            <span className="duration">4–8 weeks</span>
                            <p>Build UI, implement features, integrate backend/APIs, add analytics</p>
                        </div>
                        <div className="step">
                            <span className="step-number">4</span>
                            <h4>Launch</h4>
                            <span className="duration">1 week</span>
                            <p>TestFlight beta, fix critical bugs, submit to App Store</p>
                        </div>
                        <div className="step">
                            <span className="step-number">5</span>
                            <h4>Post-Launch Support</h4>
                            <span className="duration">2 weeks – 3 months</span>
                            <p>Monitor crashes, fix bugs, ship small updates</p>
                        </div>
                    </div>
                </section>

                {/* FAQ Section */}
                <section id="faq" className="faq-section">
                    <h2>Frequently Asked Questions</h2>
                    <div className="faq-list">
                        <div className="faq-item">
                            <h4>How many revisions are included?</h4>
                            <p>Starter gets 2 rounds of revisions. Growth gets 3 rounds. Enterprise gets unlimited within the agreed scope.</p>
                        </div>
                        <div className="faq-item">
                            <h4>What happens after I pay the deposit?</h4>
                            <p>You'll receive a link to schedule a kickoff call within 24 hours. We'll also send a short intake form to understand your goals, timeline, and must-haves. Before work begins, we'll both sign a simple SOW (Statement of Work) outlining scope and milestones.</p>
                        </div>
                        <div className="faq-item">
                            <h4>What if I need more support after launch?</h4>
                            <p>All packages include some post-launch support (2 weeks to 3 months depending on tier). If you need ongoing support, we offer monthly retainers starting at $2k/month for priority bug fixes, feature updates, and App Store management.</p>
                        </div>
                        <div className="faq-item">
                            <h4>Can you guarantee my timeline?</h4>
                            <p>We provide honest estimates based on scope. After discovery, we'll lock in a target launch date. We build in buffer for unexpected issues, but scope creep is the #1 cause of delays—which is why we define scope carefully upfront.</p>
                        </div>
                    </div>
                </section>
            </div>



            <Loader type="ball-scale-multiple" />
        </>
    )
}

export default Pricing
